import { Box, FormControl, FormLabel, Grid, Slider, Typography } from '@mui/material'
import React from 'react'
import { MySlider } from './ComponentsForConfigs/MySlider'


export const TableStructureSettings = (props) => {
  const { configs, setConfigs } = props

  return (
    <Box p={4}>
      <MySlider name="Number of thead records" value={configs.numThead} min={0} max={10} configs={configs} setConfigs={setConfigs} target="numThead" />
      <MySlider name="Number of tfoot records" value={configs.numTfoot} min={0} max={10} configs={configs} setConfigs={setConfigs} target="numTfoot" />
    </Box >
  )
}
